import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
//import Form from 'react-bootstrap/Form';
//import FormControl from 'react-bootstrap/FormControl';
//import Button from 'react-bootstrap/Button'


function Header(){

	return (
			
	
				
				<Navbar bg="success" variant="light" fixed="top">
		   			 <Navbar.Brand href="#home">Harry Potter Fan Club</Navbar.Brand>
					
					
		  		</Navbar>					

			
		);
}

export default Header;
	